import React, { useEffect, useState } from 'react';
import { formatCurrency } from '../../utils/formatting';
import { getEventDbId } from '../../utils/eventIdentity';

/**
 * Total revenue — prefers event.totalRevenue from list (?includeRevenue=true),
 * otherwise falls back to batch/single stats.
 */
const EventRevenueCell = ({ eventId, event, transformedFromV1 }) => {
  const [revenue, setRevenue] = useState(
    event?.totalRevenue != null ? Number(event.totalRevenue) : null,
  );
  const dbId = getEventDbId(event) || (eventId ? String(eventId) : '');

  useEffect(() => {
    if (event?.totalRevenue != null) {
      setRevenue(Number(event.totalRevenue));
      return;
    }
    if (!dbId || transformedFromV1) return;

    let cancelled = false;
    import('../../services/eventService')
      .then(({ fetchEventSalesData }) => fetchEventSalesData(dbId))
      .then((stats) => {
        if (!cancelled) setRevenue(stats?.totalRevenue ?? 0);
      })
      .catch(() => {
        if (!cancelled) setRevenue(0);
      });

    return () => {
      cancelled = true;
    };
  }, [dbId, transformedFromV1, event?.totalRevenue]);

  if (transformedFromV1) {
    return <span>transformed</span>;
  }

  if (!dbId) {
    return <span>—</span>;
  }

  if (revenue === null) {
    return <span>...</span>;
  }

  return <span>{formatCurrency(revenue)}</span>;
};

export default EventRevenueCell;
